import { useRef, useState } from "react"

import AssetAvailabilityCalendarIsolated, {
  AssetAvailabilityCalendarHandle,
} from "@hydrologiq/shared/components/calendar/AssetAvailabilityCalendarIsolated"
import ActivityManage from "@hydrologiq/shared/components/activities/ActivityManage"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"
import { useSectionReentry } from "@hydrologiq/shared/hooks/useSectionReentry"

function CalendarView() {
  const activityData = useRef<{ activityId: string; assetId: string } | null>(null)
  const [activityEditDialogOpen, setActivityEditDialogOpen] = useState(activityData.current !== null)

  // Refresh the calendar after dialog edits or activity deletes
  const calendarRef = useRef<AssetAvailabilityCalendarHandle>(null)

  // Planner stays mounted while inactive, so reload when we return to it.
  useSectionReentry(() => calendarRef.current?.refresh())

  // Check for calendar concept feature flag
  const calendarConceptEnabled = useGetFeature("calendar_concept")

  // Future: When concepts are created, switch based on feature flag value
  // Example:
  // if (calendarConceptEnabled === "timeline") {
  //   return <CalendarConceptTimeline onActivityEdit={handleActivityEdit} />
  // }

  return (
    <>
      <AssetAvailabilityCalendarIsolated
        ref={calendarRef}
        onActivityEdit={(activityId: string, assetId: string) => {
          activityData.current = { activityId, assetId }
          setActivityEditDialogOpen(true)
        }}
      />
      <ActivityManage
        activityId={activityData.current?.activityId}
        assetId={activityData.current?.assetId}
        isOpen={activityEditDialogOpen}
        onClose={() => {
          setActivityEditDialogOpen(false)
          activityData.current = null
          // Reload calendar so edits/deletes made in the dialog are reflected immediately.
          calendarRef.current?.refresh()
        }}
      />
    </>
  )
}

export default CalendarView
